module.exports = __webpack_public_path__ + "static/tent_static-8e1fbb451e26c292e648819d2b9d4d18.png";